/* OCD cart link: keeps a builder deck and its paid grip in step in the cart.
   Bin the grip and the deck's grip note becomes "None (removed in cart)".
   Bin the deck and its paid grip goes with it.
   Lines are matched on the hidden _build property written by the deck builder. */
(function(){
  'use strict';

  function getCart(){ return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){ return r.json(); }); }
  function change(body){
    return fetch('/cart/change.js',{ method:'POST', headers:{'Content-Type':'application/json'}, credentials:'same-origin', body:JSON.stringify(body) })
      .then(function(r){ return r.json(); });
  }

  function afterDawn(fn){
    var canSub=(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined' && PUB_SUB_EVENTS.cartUpdate);
    if(!canSub){ setTimeout(fn,1500); return; }
    var done=false;
    var unsub=subscribe(PUB_SUB_EVENTS.cartUpdate,function(){ if(done) return; done=true; unsub(); fn(); });
    setTimeout(function(){ if(done) return; done=true; unsub(); fn(); },4000);
  }

  function linked(removed){
    var buildId=removed.properties && removed.properties._build;
    if(!buildId) return Promise.resolve(false);
    var isDeck=!!(removed.properties && removed.properties['Grip']);
    return getCart().then(function(cart){
      var partner=null;
      (cart.items||[]).forEach(function(li){ if(li.properties && li.properties._build===buildId) partner=li; });
      if(!partner) return false;
      if(isDeck){ return change({ id:partner.key, quantity:0 }).then(function(){ return true; }); }
      var props={};
      Object.keys(partner.properties||{}).forEach(function(k){ if(k!=='Grip application' && k!=='_build') props[k]=partner.properties[k]; });
      props['Grip']='None (removed in cart)';
      return change({ id:partner.key, quantity:partner.quantity, properties:props }).then(function(){ return true; });
    });
  }

  function rerender(el){
    if(el && typeof el.onCartUpdate==='function'){ try{ el.onCartUpdate(); }catch(e){ location.reload(); } }
    else { location.reload(); } var foot=document.getElementById('main-cart-footer'); if(foot){ fetch('/cart?section_id='+(foot.dataset.id||'main-cart-footer')).then(function(r){ return r.text(); }).then(function(html){ var tmp=document.createElement('div'); tmp.innerHTML=html; var s=tmp.querySelector('.js-contents'); var t=foot.querySelector('.js-contents'); if(s&&t) t.innerHTML=s.innerHTML; }).catch(function(){}); }
    fetch('/?section_id=cart-icon-bubble').then(function(r){ return r.text(); }).then(function(html){
      var tmp=document.createElement('div'); tmp.innerHTML=html;
      var src=tmp.querySelector('.shopify-section')||tmp;
      var target=document.getElementById('cart-icon-bubble');
      if(target) target.innerHTML=src.innerHTML;
    }).catch(function(){});
  }

  function patch(){
    var Ctor=customElements.get('cart-items');
    if(!Ctor || Ctor.prototype.__ocdLinked) return;
    Ctor.prototype.__ocdLinked=true;
    var orig=Ctor.prototype.updateQuantity;
    Ctor.prototype.updateQuantity=function(line,quantity){
      var self=this, args=arguments;
      if(parseInt(quantity,10)!==0) return orig.apply(self,args);
      getCart().then(function(cart){
        var removed=(cart.items||[])[parseInt(line,10)-1];
        orig.apply(self,args);
        if(!removed || !removed.properties || !removed.properties._build) return;
        afterDawn(function(){
          linked(removed).then(function(changed){ if(changed) rerender(self); }).catch(function(e){ console.log('OCD cart link:',e); });
        });
      }).catch(function(){ orig.apply(self,args); });
    };
  }

  customElements.whenDefined('cart-items').then(patch);
})();